<template>
  <div>
    <Head :title="$t('auth.register.title')" />

    <div class="rounded-lg bg-white p-16 text-center">
      <div class="title text-2xl font-bold">{{ $t('auth.register.registerAccount') }}</div>
      <div class="to-login mt-2 text-lg">
        {{ $t('auth.register.hasAccount') }}
        <Link class="font-bold text-primary" :href="routes.login()">{{ $t('auth.register.goToLogin') }}</Link>
      </div>

      <el-divider />

      <el-form ref="formRef" :model="form" label-position="top" class="mx-auto !w-[360px]" size="large" @submit.prevent="submit">
        <el-form-item prop="email" :label="$t('auth.register.email')" 
          :rules="[
            { 
              validator: (rule, value, callback) => {
                if (!value && !form.phone) {
                  callback(new Error($t('auth.register.emailOrPhoneRequired')))
                } else if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                  callback(new Error($t('auth.register.emailInvalid')))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ]">
          <el-input v-model="form.email" :placeholder="$t('auth.register.emailPlaceholder')" />
        </el-form-item>

        <el-form-item prop="phone" :label="$t('auth.register.phone')"
          :rules="[
            { 
              validator: (rule, value, callback) => {
                if (!value && !form.email) {
                  callback(new Error($t('auth.register.emailOrPhoneRequired')))
                } else if (value && !/^1[3-9]\d{9}$/.test(value)) {
                  callback(new Error($t('auth.register.invalidPhone')))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ]">
          <el-input v-model="form.phone" :placeholder="$t('auth.register.phone')" />
        </el-form-item>
        
        <el-form-item prop="username" :label="$t('auth.register.username')"
          :rules="[
            { required: true, message: $t('auth.register.usernameRequired'), trigger: 'blur' },
            { min: 2, message: $t('auth.register.usernameMinLength'), trigger: 'blur' }
          ]">
          <el-input v-model="form.username" :placeholder="$t('auth.register.username')" />
        </el-form-item>

        <el-form-item prop="password" :label="$t('auth.register.password')"
          :rules="[
            { required: true, message: $t('auth.register.passwordRequired'), trigger: 'blur' },
            { min: 6, message: $t('auth.register.passwordMinLength'), trigger: 'blur' }
          ]">
          <el-input v-model="form.password" type="password" :placeholder="$t('auth.register.password')" />
        </el-form-item>

        <el-form-item prop="password_confirmation" :label="$t('auth.register.confirmPassword')"
          :rules="[
            { required: true, message: $t('auth.register.passwordConfirmRequired'), trigger: 'blur' },
            { validator: validateConfirmPassword, trigger: 'blur' }
          ]">
          <el-input v-model="form.password_confirmation" type="password" :placeholder="$t('auth.register.confirmPassword')" />
        </el-form-item>

        <el-button type="primary" class="mt-4 w-full" size="large" native-type="submit">{{ $t('auth.register.submit') }}</el-button>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { Link, Head } from "@inertiajs/vue3"

const page = usePage()
const { triggerAlert } = useFlash(page.props.flash, { useWatch: false })

const form = useForm({
  email: "",
  phone: "",
  username: "",
  password: "",
  password_confirmation: "",
})

const validateConfirmPassword = (rule, value, callback) => {
  if (value !== form.password) {
    callback(new Error($t('auth.register.passwordNotMatch')))
  } else {
    callback()
  }
}

const submit = () => {
  // form.post(routes.registration(), {
  //   onSuccess: (resp) => triggerAlert(resp?.props?.flash),
  // })
}
</script>

<script>
export default { layout: Minimal }
</script>
